/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '../../ui-elements/icon/icon.component.ngfactory';
import * as import2 from '../../ui-elements/icon/icon.component';
import * as import3 from '@angular/common';
import * as import4 from './deal-summary-icon.component';
import * as import5 from '../deal.model';
const styles_DealSummaryIconComponent:any[] = ([] as any[]);
export const RenderType_DealSummaryIconComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_DealSummaryIconComponent,
  data: {}
}
);
function View_DealSummaryIconComponent_1(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'deal-summary-count'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    ))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.dealModel.appliedDeals.length;
    ck(v,1,0,currVal_0);
  });
}
export function View_DealSummaryIconComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),7,'div',[[
        'class',
        'deal-summary'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-icon',[[
        'class',
        'deal-summary-icon'
      ]
    ],(null as any),(null as any),(null as any),import1.View_IconComponent_0,import1.RenderType_IconComponent)),
      import0.ɵdid(573440,(null as any),0,import2.IconComponent,[import0.ChangeDetectorRef],{name: [
        0,
        'name'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_DealSummaryIconComponent_1)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n'])),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import4.DealSummaryIconComponent = v.component;
    const currVal_0:any = 'tags';
    ck(v,3,0,currVal_0);
    const currVal_1:any = co.dealModel.appliedDeals.length;
    ck(v,6,0,currVal_1);
  },(null as any));
}
function View_DealSummaryIconComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-deal-summary-icon',([] as any[]),(null as any),(null as any),(null as any),View_DealSummaryIconComponent_0,RenderType_DealSummaryIconComponent)),
    import0.ɵdid(180224,(null as any),0,import4.DealSummaryIconComponent,[
      import5.DealModel,
      import0.ChangeDetectorRef
    ]
    ,(null as any),(null as any))
  ]
  ,(null as any),(null as any));
}
export const DealSummaryIconComponentNgFactory:import0.ComponentFactory<import4.DealSummaryIconComponent> = import0.ɵccf('woa-deal-summary-icon',import4.DealSummaryIconComponent,View_DealSummaryIconComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvd2ViLW9yZGVyaW5nLWFwcC93ZWItb3JkZXJpbmctYXBwL3NyYy9hcHAvZGVhbC9kZWFsLXN1bW1hcnktaWNvbi9kZWFsLXN1bW1hcnktaWNvbi5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vaG9tZS9ydW5uZXIvd29yay93ZWItb3JkZXJpbmctYXBwL3dlYi1vcmRlcmluZy1hcHAvc3JjL2FwcC9kZWFsL2RlYWwtc3VtbWFyeS1pY29uL2RlYWwtc3VtbWFyeS1pY29uLmNvbXBvbmVudC50cyIsIm5nOi8vL2hvbWUvcnVubmVyL3dvcmsvd2ViLW9yZGVyaW5nLWFwcC93ZWItb3JkZXJpbmctYXBwL3NyYy9hcHAvZGVhbC9kZWFsLXN1bW1hcnktaWNvbi9kZWFsLXN1bW1hcnktaWNvbi5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2hvbWUvcnVubmVyL3dvcmsvd2ViLW9yZGVyaW5nLWFwcC93ZWItb3JkZXJpbmctYXBwL3NyYy9hcHAvZGVhbC9kZWFsLXN1bW1hcnktaWNvbi9kZWFsLXN1bW1hcnktaWNvbi5jb21wb25lbnQudHMuRGVhbFN1bW1hcnlJY29uQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPGRpdiBjbGFzcz1cImRlYWwtc3VtbWFyeVwiPlxuICAgIDx3b2EtaWNvbiBjbGFzcz1cImRlYWwtc3VtbWFyeS1pY29uXCIgW25hbWVdPVwiJ3RhZ3MnXCI+PC93b2EtaWNvbj5cbiAgICA8ZGl2ICpuZ0lmPVwiZGVhbE1vZGVsLmFwcGxpZWREZWFscy5sZW5ndGhcIlxuICAgICAgICAgY2xhc3M9XCJkZWFsLXN1bW1hcnktY291bnRcIj57e2RlYWxNb2RlbC5hcHBsaWVkRGVhbHMubGVuZ3RofX08L2Rpdj5cbjwvZGl2PlxuIiwiPHdvYS1kZWFsLXN1bW1hcnktaWNvbj48L3dvYS1kZWFsLXN1bW1hcnktaWNvbj4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztNQ0VJO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFDZ0M7TUFBQTtNQUFBO0lBQUE7SUFBQTs7OztJQUFBO0lBQUE7Ozs7O01BSHBDO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFBMEI7TUFDdEI7UUFBQTtRQUFBO01BQUE7SUFBQTtrQkFBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBQStEO0lBQy9EO2dCQUFBOzs7SUFBQTtPQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFDdUU7SUFDckU7Ozs7SUFIa0M7SUFBcEMsU0FBb0MsU0FBcEM7SUFDSztJQUFMLFNBQUssU0FBTDs7Ozs7SUNGSjtnQkFBQTs7O0lBQUE7S0FBQTs7OzsifQ==



// WEBPACK FOOTER //
// ./src/app/deal/deal-summary-icon/deal-summary-icon.component.ngfactory.ts